import { parseXML } from '../xmlParser';

export function parseFormData(formData: string) {
  const formXml = parseXML(formData);

  // @ts-ignore
  const [root]: [root: Element] = formXml.getElementsByTagName('liveForm') || [];

  const formOrderPropertyList = root.getElementsByTagName('FormOrderPropertyList')?.[0];
  const liveFormOrder = root.getElementsByTagName('LiveFormOrder')?.[0];
  const testScenarios = root.getElementsByTagName('TestScenarios')?.[0];
  const formItems = root.getElementsByTagName('FormItems')?.[0];

  return { root, formOrderPropertyList, liveFormOrder, testScenarios, formItems };
}
